import { NavLink } from "react-router-dom";

// Cada pestaña tiene su propio color (paleta Vívelo sobre azul profundo):
// verde = inicio/avance, amarillo = oportunidad, azul claro = ruta, morado = IA, naranja = agenda.
const items = [
  { to: "/app/dashboard", label: "Inicio", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill", color: "#20C997" },
  { to: "/app/prospectar", label: "Prospectar", icon: "ri-radar-line", activeIcon: "ri-radar-fill", color: "#FACC15" },
  { to: "/app/mi-ruta", label: "Mi Ruta", icon: "ri-route-line", activeIcon: "ri-route-fill", color: "#60A5FA" },
  { to: "/app/guia-ia", label: "Guía IA", icon: "ri-robot-2-line", activeIcon: "ri-robot-2-fill", color: "#A78BFA" },
  { to: "/app/reuniones", label: "Calendario", icon: "ri-calendar-event-line", activeIcon: "ri-calendar-event-fill", color: "#FB923C" },
];

export default function BottomNav() {
  return (
    <nav
      // "fixed" (no "sticky"): queda clavado a la pantalla sin importar el scroll
      // de la página o de cualquier sección dentro de ella.
      className="fixed bottom-0 left-0 right-0 z-30 bg-[#0B1F3A] border-t border-white/10 shadow-[0_-6px_20px_rgba(2,8,23,0.35)] pb-[env(safe-area-inset-bottom)] vv-safe-x"
      aria-label="Navegación principal"
    >
      <ul className="max-w-6xl mx-auto grid grid-cols-5 px-2">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              className={({ isActive }) =>
                [
                  "flex flex-col items-center justify-center gap-1 py-2.5 text-xs font-bold cursor-pointer whitespace-nowrap transition-colors",
                  isActive ? "text-white" : "text-white/80 hover:text-white",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className="w-10 h-7 rounded-full flex items-center justify-center transition-colors"
                    style={{ color: it.color, backgroundColor: isActive ? `${it.color}29` : "transparent" }}
                  >
                    <i className={`${isActive ? it.activeIcon : it.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <span>{it.label}</span>
                  {/* Punto indicador: siempre ocupa el mismo espacio (solo cambia de color)
                      para que los 5 botones midan igual sin importar cuál esté activo. */}
                  <span
                    className="w-1 h-1 rounded-full -mt-0.5 transition-colors"
                    style={{ backgroundColor: isActive ? it.color : "transparent" }}
                    aria-hidden="true"
                  ></span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
